import React, { useState, useEffect } from "react";
import OtpInput from "react-otp-input";
import styled from "styled-components";
import { Box, Span } from "@bpba/ui-components";
import { theme } from "@bpba/ui-components";

type FormOTPProps = {
  otpCallback: (otp: string) => void;
};

export const FormOTP = (props: FormOTPProps) => {
  const [otp, setOTP] = useState<string>("");

  useEffect(() => {
    if (otp.length === 6) {
      const timer = setTimeout(() => {
        props.otpCallback(otp);
      }, 250);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [otp, props]);

  return (
    <Box
      justifyContent="center"
      marginTop={"48px"}
      flexDirection="column"
      alignItems={"center"}
    >
      <OtpInput
        value={otp}
        inputType="number"
        onChange={(data) => {
          setOTP(data);
        }}
        numInputs={6}
        renderSeparator={
          <Span mx={["4px", "8px"]} color={theme.colors.primary[0]}>
            -
          </Span>
        }
        renderInput={(props) => <StyledOTP {...props} />}
      />
      <Span mt={"36px"} fontWeight={600} color={theme.colors.primary[0]}>
        Ingresá el código enviado a tu mail
      </Span>
    </Box>
  );
};

const StyledOTP = styled.input({
  padding: "0px !important",
  fontSize: "40px !important",
  height: "50px !important",
  borderBottom: `3px solid ${theme.colors.primary[0]} !important`,
  color: `${theme.colors.primary[0]} !important`,
  userSelect: "none",
  caretColor: "transparent",
  "&::selection": {
    backgroundColor: "transparent",
  },
});
